import React from 'react'
import Orders from './list/ListOrders.page';

function CashierOrdersPage() {
	return (
		<Orders
			title="طلبات المحل"
			fixedFilters={{
				is_cashier: true,
			}}
		/>
	);
}

export default CashierOrdersPage;